// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eptLGRjoavefIU {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: TKlNoXeC7AEDfD;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 16px;
  margin-bottom: var(--ds-space-100, 8px);
}
@keyframes TKlNoXeC7AEDfD {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .eptLGRjoavefIU {
    animation: none;
  }
}
.D3Z8CiRsEE1W_L {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: TKlNoXeC7AEDfD;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 40px;
  margin-bottom: var(--ds-space-200, 16px);
}
@keyframes TKlNoXeC7AEDfD {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .D3Z8CiRsEE1W_L {
    animation: none;
  }
}
.j7i5B1DSrDgNyX {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: TKlNoXeC7AEDfD;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 32px;
}
@keyframes TKlNoXeC7AEDfD {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .j7i5B1DSrDgNyX {
    animation: none;
  }
}
.hQwoeZIOjwZuG8 {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-100, 8px);
  margin-top: var(--ds-space-200, 16px);
}
.czGpK90SxMhJHY {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 396px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonLabelText": `eptLGRjoavefIU`,
	"shimmer": `TKlNoXeC7AEDfD`,
	"skeletonFormInput": `D3Z8CiRsEE1W_L`,
	"skeletonButton": `j7i5B1DSrDgNyX`,
	"buttonGroup": `hQwoeZIOjwZuG8`,
	"addCardToPlannerPopover": `czGpK90SxMhJHY`
};
export default ___CSS_LOADER_EXPORT___;
